import axios from "axios";
import { Notify } from "notiflix";
import { FaPhoneAlt } from "react-icons/fa";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";
import { useNavigate, Link } from "react-router-dom";
import { useContext, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import "./CommonProfileCard.css";

const CommonProfileCard = ({ profile, setReload }) => {
    const Navigate = useNavigate();
    const { language } = useContext(LanguageContext);

    const [loading, setLoading] = useState(null);
    // loading = { type: "interest" | "shortlist" | "purchase", id: number }

    const token = JSON.parse(localStorage.getItem("kkm_auth"));
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    };

    const handleAction = (url, type, id, callback) => {
        setLoading({ type, id });
        axios.post(url, { RequestedId: id }, { headers })
            .then((response) => {
                if (response.data.status) {
                    Notify.success(response.data.message);
                    if (callback) callback();
                } else {
                    Notify.failure(response.data.message);
                }
                setReload(pre => !pre);
            })
            .finally(() => setLoading(null));
    };

    const HandlePurchaseMobileNumber = (id) => {
        Confirm.show(
            "Purchase Mobile Number",
            "Are you sure you want to purchase this profile? This will deduct 1 point from your wallet.",
            "Yes, Purchase",
            "Cancel",
            () => {
                handleAction(
                    "https://kovaikongunadumatrimony.com/kkm_backend/public/api/purchase-mobile-number",
                    "purchase",
                    id,
                    () => Navigate("/purchased-profiles")
                );
            }
        );
    };

    const HandleAlreadyNumberBought = (id) => {
        Navigate(`/view/${id}`);
    };

    const WaveLoader = () => (
        <span className="wave-loader">
            <span></span>
            <span></span>
            <span></span>
        </span>
    );

    return (
        <div className="profile-card2">
            <div className="profile-card">
                <div className="profile-img-wrapper">
                    <img
                        src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${profile.profile_photo_1}`}
                        alt={language === "ta" ? "சுயவிவர படம்" : "Profile"}
                        className="profile-img"
                    />
                </div>

                <div className="profile-details" style={{ position: "relative" }}>
                    {/* Phone Button */}
                    <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                        {profile.MobileNumberStatus == 0 ? (
                            <button
                                type="button"
                                onClick={() => HandlePurchaseMobileNumber(profile.profile_id)}
                                className="circle-btn outline-green"
                                disabled={loading?.type === "purchase" && loading?.id === profile.profile_id}
                            >
                                {loading?.type === "purchase" && loading?.id === profile.profile_id ? (
                                    <WaveLoader />
                                ) : (
                                    <FaPhoneAlt />
                                )}
                            </button>
                        ) : (
                            <button
                                onClick={() => HandleAlreadyNumberBought(profile.profile_id)}
                                type="button"
                                className="circle-btn solid-green"
                            >
                                <FaPhoneAlt />
                            </button>
                        )}
                    </div>

                    {/* Profile Details */}
                    <p><strong>{language === "ta" ? "பதிவு எண்" : "Register Number"}</strong>: {profile.profile_id}</p>
                    <p><strong>{language === "ta" ? "பெயர்" : "Name"}</strong>: {profile.name}</p>
                    <p><strong>{language === "ta" ? "வயது" : "Age"}</strong>: {profile.age}</p>
                    <p><strong>{language === "ta" ? "ஜாதகம்" : "Jathagam"}</strong>: {profile.jathagam}</p>
                    <p><strong>{language === "ta" ? "நட்சத்திரம்" : "Star"}</strong>: {profile.star}</p>
                    <p>
                        <strong>{language === "ta" ? "பதிவு தேதி " : "Register Date"}</strong>:
                        {(() => {
                            const dateStr = profile.created_at.split(" ")[0]; 
                            const [year, month, day] = dateStr.split("-");  
                            return `${day}-${month}-${year}`;              
                        })()}
                    </p>
                    <p><strong>{language === "ta" ? "ராசி" : "Rasi"}</strong>: {profile.rasi}</p>

                    {/* Footer Buttons */}
                    <div className="profile-footer">
                        <Link to={`/view/${profile.profile_id}`} className="btn view-btn">
                            <i className="fas fa-eye"></i> {language === "ta" ? "சுயவிவரம் பார்க்க" : "View Profile"}
                        </Link>

                        {/* Interest Button */}
                        {profile.interest_status == 0 ? (
                            <button
                                className="btn interest-btn"
                                onClick={() => handleAction(
                                    "https://kovaikongunadumatrimony.com/kkm_backend/public/api/send-interested",
                                    "interest",
                                    profile.profile_id
                                )}
                                disabled={loading?.type === "interest" && loading?.id === profile.profile_id}
                            >
                                {loading?.type === "interest" && loading?.id === profile.profile_id ? (
                                    <WaveLoader />
                                ) : (
                                    <><i className="fas fa-heart"></i> {language === "ta" ? "ஆர்வம்" : "Send Interest"}</>
                                )}
                            </button>
                        ) : (
                            <button
                                className="btn interested-btn"
                                onClick={() => handleAction(
                                    "https://kovaikongunadumatrimony.com/kkm_backend/public/api/remove-interested",
                                    "interest",
                                    profile.profile_id
                                )}
                                disabled={loading?.type === "interest" && loading?.id === profile.profile_id}
                            >
                                {loading?.type === "interest" && loading?.id === profile.profile_id ? (
                                    <WaveLoader />
                                ) : (
                                    <><i className="fas fa-heart"></i> {language === "ta" ? "ஆர்வம் காட்டப்பட்டது" : "Interested"}</>
                                )}
                            </button>
                        )}

                        {/* Shortlist Button */}
                        {profile.short_list_status == 0 ? (
                            <button
                                className="btn shortlist-btn"
                                onClick={() => handleAction(
                                    "https://kovaikongunadumatrimony.com/kkm_backend/public/api/short-list-profile",
                                    "shortlist",
                                    profile.profile_id
                                )}
                                disabled={loading?.type === "shortlist" && loading?.id === profile.profile_id}
                            >
                                {loading?.type === "shortlist" && loading?.id === profile.profile_id ? (
                                    <WaveLoader />
                                ) : (
                                    <><i className="fas fa-star"></i> {language === "ta" ? "குறிப்பிட்ட பட்டியல்" : "Add Shortlist"}</>
                                )}
                            </button>
                        ) : (
                            <button
                                className="btn shortlisted-btn"
                                onClick={() => handleAction(
                                    "https://kovaikongunadumatrimony.com/kkm_backend/public/api/remove-short-list-profile",
                                    "shortlist",
                                    profile.profile_id
                                )}
                                disabled={loading?.type === "shortlist" && loading?.id === profile.profile_id}
                            >
                                {loading?.type === "shortlist" && loading?.id === profile.profile_id ? (
                                    <WaveLoader />
                                ) : (
                                    <><i className="fas fa-star"></i> {language === "ta" ? "பட்டியலில் சேர்க்கப்பட்டது" : "Shortlisted"}</>
                                )}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommonProfileCard;
